<template>
  <div class="block" style="width: 100%; height: 100%; position: absolute">
    <h1>{{ name }}</h1>
    <div v-if="show_flag" style="bottom: 0; position: absolute; width: 100%; height: 793px">
      <el-carousel height="793px">
        <el-carousel-item v-for="item in imagesbox" :key="item.id">
          <el-image
            style="width: 100%; height: 100%;"
            :src="item.idView"
            :object-fit="fit"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div v-else style="font-size: 22px;color: white;margin-left: 5%;margin-top: 5%">
      <div style="float:left;margin-right: 10%;text-align: left;">
        <p>Project Progess:{{ progess }}</p>
        <p>Architectural:{{ architectural }}</p>
        <p>Structural:{{ structural }}</p>
        <p>M&E:{{ me }}</p>
        <p>Project GFA:{{ gfa }}</p>
      </div>
      <div style="float:left;text-align: left">
        <p>Project Start Date:{{ start_date }}</p>
        <p>Project End Date:{{ end_date }}</p>
        <p>Project Contract Sum:{{ contract_sum }}</p>
        <p>Project Developer:{{ developer }}</p>
        <p>Project Consultant:{{ consultant }}</p>
      </div>
    </div>

  </div>


</template>

<script>
export default {
  name: "spot",
  data() {
    return {
      legendArr: [],
      color: this.$store.state.color.dashboard_color,
      myChart: null,
      name: 'Construction Site',
      show_flag: true,
      progess: 'N/A',
      architectural: 'N/A',
      structural: 'N/A',
      me: 'N/A',
      gfa: 'N/A',
      start_date: 'N/A',
      end_date: 'N/A',
      contract_sum: 'N/A',
      developer: 'N/A',
      consultant: 'N/A',
      count: 0,
      imagesbox: [],
      fit: 'contain',
      project_id: ''
    }
  },
  mounted() {
    // setInterval(() => {
    //   this.count += 1
    //   if (this.count > 10) {
    //     this.show_flag= !this.show_flag
    //     this.count = 0
    //   }
    // },1000);
    this.project_id = this.$route.query.proj_id
    if (this.project_id == '1196') {
      this.imagesbox = [{id: 0, idView: require("../../assets/spot_5.jpg")}]
    }
    if (this.project_id == '2096') {
      this.imagesbox = [{id: 0, idView: require("../../assets/spot2096.png")},
        {id: 1, idView: require("../../assets/spot20963.png")}]
    }
    if (this.project_id == '2419') {
      this.imagesbox = [{id: 0, idView: require("../../assets/spot2419-1.png")},
        {id: 1, idView: require("../../assets/spot2419-2.png")}]
    }
  }
}

</script>

<style lang="stylus" scoped>
h1
  position absolute
  display flex
  height 70px
  line-height 70px
  top -27px
  color white
  width 100%
  font-size 42px
  font-weight bold
  padding-left 20px

/*html, body, #container {
  height 100%
  width 100%
  overflow auto
  margin 0 auto
}*/

/*.spot_title
  height 50px
  font-size 16px
  color #ccc
  text-align left*/

/*.el-carousel__item:nth-child(4n) {
  height 100%;
  background: url("../../assets/spot_1.jpg");
  !*-webkit-background-size contain*!
  background-repeat no-repeat
  background-size 100% 100%
}

.el-carousel__item:nth-child(4n+1) {
  height 100%;
  background: url("../../assets/spot_2.jpg");
  !*-webkit-background-size contain*!
  background-repeat no-repeat
  background-size 100% 100%
}

.el-carousel__item:nth-child(4n+2) {
  height 100%;
  background: url("../../assets/spot_3.jpg");
  !*-webkit-background-size contain*!
  background-repeat no-repeat
  background-size 100% 100%
}

.el-carousel__item:nth-child(4n+3) {
  height 100%;
  background: url("../../assets/spot_4.jpg");
  !*-webkit-background-size contain*!
  background-repeat no-repeat
  background-size 100% 100%
}*/

.el-carousel__container {
  height: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/spot/spot.vue